import React from 'react';

const steps = [
  {
    title: 'Discovery call',
    description:
      'We spend 30 minutes understanding your business, the problem you want to solve, and whether AI is genuinely the right tool. No sales pitch, just an honest conversation.',
  },
  {
    title: 'Build & iterate',
    description:
      'We design, build, and ship a working solution fast. You get visibility throughout: demos, feedback loops, and clear progress. No black-box development.',
  },
  {
    title: 'Deploy & scale',
    description:
      'Your solution goes live in your environment, not a sandbox. We stay on to monitor, tune, and scale it as your usage grows. Many clients keep us on as an ongoing AI partner.',
  },
];

const Purpose: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-2xl mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-black leading-[1.05] tracking-[-0.02em] mb-5">
            How it works
          </h2>
          <p className="text-lg text-neutral-600 leading-relaxed">
            From first conversation to production. Here's what working with us looks like.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 md:gap-16">
          {steps.map((step) => (
            <div key={step.title}>
              <h3 className="text-xl font-semibold text-black mb-3 tracking-tight">{step.title}</h3>
              <p className="text-neutral-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Purpose;
